import { NotificationStatus } from '@/fsd/entities/notifications/model/types/types';
import { useIntersectionObserver } from '@/fsd/shared/hooks/useIntersectionObserver';
import EmptyData from '@/fsd/shared/ui/EmptyData/EmptyData';
import Loader from '@/fsd/shared/ui/Loader/Loader';
import { observer } from 'mobx-react-lite';
import { useRef } from 'react';
import { useAllNotificationsList } from '../../model/hooks/useAllNotificationsList';
import NotificationItem from '../NotificationItem/NotificationItem';
import styles from './AllNotificationsList.module.scss';

export interface IAllNotificationListProps {
  status: NotificationStatus;
}

const AllNotificationsList = observer(
  ({ status }: IAllNotificationListProps) => {
    const rootRef = useRef<HTMLDivElement | null>(null);
    const {
      notificationList,
      loading,
      fetchNextPage,
      hasNextPage,
      isFetchingNextPage,
    } = useAllNotificationsList({ status });
    const { observerRef } = useIntersectionObserver({
      onIntersect: fetchNextPage,
      enabled: hasNextPage,
      root: rootRef,
    });


    return (
      <div className={styles.list} ref={rootRef}>
        {loading ? (
          <EmptyData desc={<Loader />} />
        ) : !notificationList || notificationList.length === 0 ? (
          <EmptyData desc="Нет данных" />
        ) : (
          <>
            {notificationList.map((item) => (
              <NotificationItem key={item.id} item={item} status={status} />
            ))}
            <div ref={observerRef} style={{ padding: '1px' }}>
              .
            </div>
          </>
        )}
        {isFetchingNextPage && <Loader className={styles.loader} />}
      </div>
    );
  }
);

export default AllNotificationsList;
